import React from "react";
import DashboardLayout from "@/components/DashboardLayout";
import { LayoutDashboard, Wallet, User } from "lucide-react";

const nav = [
  { to: "/seller", label: "Dashboard", icon: LayoutDashboard },
  { to: "/seller/wallet", label: "Commission Wallet", icon: Wallet },
  { to: "/learner/profile", label: "Profile", icon: User },
];

export default function SellerLayout() {
  return <DashboardLayout nav={nav} title="Content Seller" />;
}
